import { Component, signal } from '@angular/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { moon, sunnyOutline } from 'ionicons/icons';

@Component({
  selector: 'cmn-switch-theme-button',
  templateUrl: './switch-theme-button.component.html',
  imports: [IonButton, IonIcon],
})
export class SwitchThemeButtonComponent {
  public paletteToggle = signal(true);

  public constructor() {
    addIcons({ sunnyOutline, moon });
  }

  public toggleChange(): void {
    this.paletteToggle.set(!this.paletteToggle());
    document.documentElement.classList.toggle(
      'ion-palette-dark',
      this.paletteToggle(),
    );
  }
}
